import { Button, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const CouponCodeFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${Spacing.S12};
`

export const SubmitButton = styled(Button)`
  margin-top: ${Spacing.S8};
`
